@if (settings.showItemsTierListMessage()) {
  <div class="info box reset-font" style="margin-bottom: 12px;">
    <div class="close-info-btn" (click)="hideInfoMessage()">✕</div>
    <h3 class="info-title">Explainer: <strong>Items Tier List</strong></h3>

    <div class="info-box-body">
      <app-content cid="explainer-items-tier-list" contentType="tip" [conditions]="{ poe1: poe1, poe2: poe2 }"></app-content>
      <p><a class="remove-warning-link" (click)="hideInfoMessage()">(I understand, dismiss)</a></p>
    </div>
  </div>
}

<div class="tier-list-info">
  <div class="tier-input">
    <span>
      <span>Type</span>
      <app-select class="inline" style="width: 140px" [searchable]="false" [disabled]="false" [(ngModel)]="selectedSelectionFilter" (selectedValueChange)="buildTierList()">
        @for (filter of selectionFilters; track filter.value) {
          <app-option [value]="filter.value" [text]="filter.text"></app-option>
        }
      </app-select>
    </span>

    @if (selectedSelectionFilter === 'All' || selectedSelectionFilter === 'my' || selectedSelectionFilter === 'other') {
      <span>
        <span>Equipment Slot</span>
        <app-select class="inline" style="width: 140px" [searchable]="false" [disabled]="false" [(ngModel)]="selectedSlotFilter" (selectedValueChange)="buildTierList()">
          @for (filter of slotFilters; track filter.value) {
            <app-option [value]="filter.value" [text]="filter.text"></app-option>
          }
        </app-select>
      </span>

      <span>
        <span>Equipment Category</span>
        <app-select class="inline" style="width: 140px" [searchable]="false" [disabled]="false" [(ngModel)]="selectedCategoryFilter" (selectedValueChange)="buildTierList()">
          @for (filter of categoryFilters; track filter.value) {
            <app-option [value]="filter.value" [text]="filter.text"></app-option>
          }
        </app-select>
      </span>
    }
  </div>

  <div class="tier-input tier-options">
    <div class="tier-values-toggle-buttons">
      <app-tooltip-wrapper [right]="true">
        <button type="button" class="btn toggle-button" [class.active]="filter.equipmentTieringMode === 'Subtle'" (click)="selectTieringMode('Subtle')">Subtle</button>
        <ng-template #tooltip>Only puts equipment with the highest potential into a higher tier; remaining equipment is largely grouped together in the same tier.</ng-template>
      </app-tooltip-wrapper>

      <app-tooltip-wrapper [right]="true">
        <button type="button" class="btn toggle-button" [class.active]="filter.equipmentTieringMode === 'Tiered'" (click)="selectTieringMode('Tiered')">Tiered</button>
        <ng-template #tooltip>Eagerly divides equipment into tiers the better its potential. Warning: Increases filter output size.</ng-template>
      </app-tooltip-wrapper>
    </div>
  </div>
</div>

<div class="tier-list">
  @for (tierColumn of tierColumns; track $index) {
    <div class="tier-column">
      @for (tier of tierColumn; track tier.tier) {
        <div class="tier"
              (dragenter)="onDragEnter($event, tier)"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event, tier)"
              (drop)="onDrop($event, tier)"
              [class.drag-over]="tier.isDragOver">
          <app-tier-style [displayable]="tier.cosmetics" [allowedDisplayTypes]="[DisplayType.Custom]" [allowDisactivate]="false"
            [label]="tier.name" [isHeader]="true" [isTitle]="true" [exampleName]="tier.exampleName" [allowHide]="false"
            [styleDialogTitle]="tier.styleDialogTitle" (styleUpdated)="buildTierList()"></app-tier-style>
          <div class="tier-item-types">
            @for (equipmentSection of tier.equipmentSections; track equipmentSection.sectionName) {
              <div class="equipment-section">
                @for (itemType of equipmentSection.itemTypes; track itemType.itemType) {
                  <div class="tier-item-type">
                    <div class="tier-item-type-title"><h4>{{ itemType.itemType }}</h4></div>
                    <div class="tier-item-type-body">
                      @for (baseType of itemType.baseTypes; track baseType.equipmentType) {
                        <div class="tier-item-type-base-type"
                          [draggable]="!ruleNavActive()"
                          (dragstart)="onDragStart($event, baseType)"
                          (dragend)="onDragEnd()"
                          (mouseenter)="onItemMouseEnter(baseType)"
                          (mouseleave)="onItemMouseLeave()"
                          (click)="onItemClick($event, baseType)"
                          [class.dragged]="draggedItem?.equipmentType === baseType.equipmentType"
                          [class.rule-nav-hovered]="isRuleNavHovered(baseType)">
                          <app-equipment-label
                            [equipment]="baseType!"
                            [hideTooltip]="draggedItem?.equipmentType == baseType.equipmentType || isRuleNavHovered(baseType)"
                            [icon]="baseType.icon"
                          ></app-equipment-label>
                          @if (baseType.originalTier && baseType.originalTier !== tier.tier) {
                            <span class="original-tier" (click)="resetToOriginalTier(baseType)"
                              title="Reset to original {{ baseType.originalTier }}-tier">↻</span>
                          }
                          @if (baseType.hasCustomRuleStyle && baseType.ruleId) {
                            <app-custom-rule-style-picker
                              class="custom-rule-style-preview"
                              [filter]="filter"
                              [ruleId]="baseType.ruleId"
                              [active]="true"
                              [exampleName]="baseType.displayName"
                              [right]="false"
                              (styleUpdated)="buildTierList()"></app-custom-rule-style-picker>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

